import { render, staticRenderFns } from "./listarloteamostras.vue?vue&type=template&id=c0b99598&"
import script from "./listarloteamostras.vue?vue&type=script&lang=js&"
export * from "./listarloteamostras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports